import 'url-search-params-polyfill'

const FilterUrl = {
  // Creates a query parameter string based on options
  currentStateUrlParamsString(options) {
    const searchParams = this.currentStateUrlParams(options)

    // Return either the query string with a ? on the front, or an empty string.
    if (searchParams.toString() !== '') {
      return `?${searchParams.toString()}`
    } else {
      return ''
    }
  },

  currentStateUrlParamsHash(options) {
    const searchParams = this.currentStateUrlParams(options)

    return Object.fromEntries(searchParams)
  },

  currentStateUrlParams(options) {
    let searchParams = new URLSearchParams('')

    if (options.presetFilter !== undefined && options.presetFilter !== null) {
      searchParams.append('filter', options.presetFilter)
    } else if (options.filters !== undefined) {
      // options.filters, if present, is expected to be formatted like
      // [{type: 'country', value: 'FR'}, {type: 'category', value: 'environment'}]
      for (let filter of options.filters) {
        let serializedValue = null
        if (typeof filter.value === 'string' || typeof filter.value === 'number') {
          serializedValue = filter.value
        } else {
          serializedValue = JSON.stringify(filter.value)
        }

        searchParams.append(`filter[${filter.type}]`, serializedValue)
      }
    }

    // options.sortParams, if present, is expected to be formatted like
    // {column: 'created_at', direction: 'desc'}
    if (options.sortParams !== undefined) {
      if (options.sortParams.column) {
        searchParams.append('sort', options.sortParams.column)
      }
      if (options.sortParams.direction) {
        searchParams.append('direction', options.sortParams.direction)
      }
    }

    // options.pagination, if present, is expected to be formatted like
    // {currentPage: 1}
    if (options.pagination !== undefined) {
      if (options.pagination.currentPage > 0) {
        searchParams.append('page', options.pagination.currentPage.toString())
      }
    }

    // options.otherSearchParams, if present is expected to be formatted like
    // { akid: 'x', utm_source: 'a' }
    if (options.otherSearchParams) {
      Object.entries(options.otherSearchParams).forEach(([k, v]) => {
        searchParams.append(k, v)
      })
    }

    return searchParams
  },

  currentStateFromUrl() {
    let state = { sortParams: {}, pagination: {}, filters: [] }
    let query = new URLSearchParams(location.search)

    for (let item of query) {
      if (item[0] === 'sort') {
        state.sortParams.column = item[1]
      }
      else if (item[0] === 'direction') {
        state.sortParams.direction = item[1]
      }
      else if (item[0] === 'page') {
        state.pagination.currentPage = parseInt(item[1])
      }
      else if (item[0].startsWith('filter[')) {
        let filterType = item[0].match(/^filter\[(.*)\]$/)[1]

        let parsedValue = null
        if (item[1].startsWith('{') || item[1].startsWith('[') || item[1].startsWith('"') ||
            item[1] === 'true' || item[1] === 'false') {
          parsedValue = JSON.parse(item[1])
        } else {
          parsedValue = item[1]
        }

        state.filters.push({type: filterType, value: parsedValue})
      }
      else if (item[0] === 'filter') {
        state.presetFilter = item[1]
      }
    }

    return state
  }
}

export default FilterUrl
